import Image from 'next/image'
import Link from 'next/link'

import { AspectRatio } from '@/components/primitives/AspectRatio/AspectRatio'
import { ButtonLink } from '@/components/primitives/Button/Button'
import { Card as CardUI, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'

export const ProductCard = ({
  title,
  collection,
  image,
  link,
  onClick,
}: {
  title: string
  collection: string
  image?: { url: string; altText: string | null }
  link: string
  onClick?: () => void
}) => {
  return (
    <CardUI className="flex size-full flex-col items-stretch justify-between rounded-none border-none bg-white shadow-none">
      <CardHeader className="mx-auto my-2 flex min-h-[164px] w-full bg-transparent p-0">
        <AspectRatio ratio={'1/1'}>
          <Link onClick={onClick} href={link} className="size-full">
            {image?.url ? (
              <Image alt={image?.altText ?? 'Product Card Image'} width={180} height={180} src={image.url} className="aspect-square size-full bg-white object-cover" />
            ) : (
              <div className="flex aspect-square size-full items-center justify-center bg-white" />
            )}
          </Link>
        </AspectRatio>
      </CardHeader>
      <CardContent className="flex w-full flex-col items-center justify-between p-4 !pt-0 md:p-6">
        <div className="flex flex-col items-center justify-center ">
          <CardDescription className="mb-1 text-sm font-medium text-primary-500">{collection}</CardDescription>
          <CardTitle className="md:md-6 mb-4 text-center font-heading text-2xl font-bold uppercase leading-6 text-grey-900 md:text-3xl">{title}</CardTitle>
        </div>
        <ButtonLink className="w-full" variant="outline" href={link} onClick={onClick}>
          Learn more<span className="sr-only"> about {title}</span>
        </ButtonLink>
      </CardContent>
    </CardUI>
  )
}
